module.exports = __webpack_public_path__ + "static/pic09-b86ee1e78589bbf6bca91bb2303b3196.jpeg";